import styled, { css } from 'styled-components';
import { size } from '../../../../styled-components/layout/helpers';

export const Items = styled.ul`
  list-style: none;
  padding: 0;
  margin-bottom: 0;
`;

interface ItemProps {
  $active?: boolean;
}

const Item = styled.li<ItemProps>`
  box-sizing: border-box;
  background-color: var(--c-global-search-item-bg);
  border-radius: 3px;
  padding: ${size(1.65)} ${size(2)};
  cursor: pointer;
  border: 1px solid transparent;

  ${({ $active }) =>
    $active &&
    css`
      border: 1px solid var(--c-contrast-bg);
    `}

  & + & {
    margin-top: 0.5rem;
  }
`;

export const AiItem = styled(Item)`
  ${({ $active }) =>
    $active &&
    css`
      color: var(--c-contrast-fg);
      background-color: var(--c-contrast-bg);
    `}
`;

export const AiIconWrapper = styled.div`
  color: var(--c-text-main);
  background-color: var(--c-bg-main);
  padding: ${size(0.5)};
  border-radius: ${size(1)};
`;

export default Item;
